/*
 * Financial Services Messages
 *
 * This contains all the text for the FinancialServices container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.EmergencyReliefFund';

export default defineMessages({
  introduction: {
    defaultMessage: 'Introduction',
  },
  additionalInformation: {
    defaultMessage: 'Additional Information',
  },
  confirmation: {
    defaultMessage: 'Confirmation',
  },
  header: {
    defaultMessage: 'Employee Emergency Relief Fund',
  },
  next: {
    defaultMessage: 'Next',
  },
  theEmployeeReliefFundServices: {
    defaultMessage:
      'The Employee Relief Fund services may assist you with dealing with temporary or immediate financial challenges during difficult times of transition or trauma, so that you may focus on the health of you and your family.',
  },
  someExamples0fSituationsWhere: {
    defaultMessage:
      'Some examples of situations where an Emergency Relief Fund may be used are: Funerary services for a deceased family member, emergency house or car repairs, an event that makes it impossible to pay for basic living expenses (e.g., flood, fire, robbery, domestic violence), temporary medical expenses not otherwise covered by benefits.',
  },
  contact: {
    defaultMessage: 'Phone number to be contacted',
  },
  leaveMessage: {
    defaultMessage: 'Would you like to be left a voicemail message?',
  },
  additional: {
    defaultMessage:
      'Please describe the nature of your circumstances and the reason behind requesting financial assistance.',
  },
  submit: {
    defaultMessage: 'Submit',
  },
  previous: {
    defaultMessage: 'Previous',
  },
  yes: {
    defaultMessage: 'Yes',
  },
  no: {
    defaultMessage: 'No',
  },
  loanAmount: {
    defaultMessage: 'What is the amount being requested?',
  },
  confirmationCopy: {
    defaultMessage:
      'Your request has been received! Your loan advisor will be in touch shortly to confirm eligibility, outline documentation requirements and ask some additional questions. You should receive a call within 1 business day.',
  },
  returnToDash: {
    defaultMessage: 'Return to Dashboard',
  },
  missingDob: {
    defaultMessage: 'Please enter a date of birth on your Preferences page.',
  },
});
